import * as addressAS from './address';
import * as carModelAS from './carModel';
import * as employmentAS from './employment';
import * as makeAS from './make';
import * as modelYearAS from './modelYear';
import * as postalCodeAS from './postalCode';
import * as insuranceCompaniesAS from './insuranceCompanies';
import * as petBreedAS from './petBreed';
import * as dogBreedAS from './dogBreed';

export const getAutoSuggest = variant => {
  switch (variant) {
    case postalCodeAS.type:
      return postalCodeAS;
    case addressAS.type:
      return addressAS;
    case employmentAS.type:
      return employmentAS;
    case carModelAS.type:
      return carModelAS;
    case makeAS.type:
      return makeAS;
    case modelYearAS.type:
      return modelYearAS;
    case insuranceCompaniesAS.type:
      return insuranceCompaniesAS;
    case petBreedAS.type:
      return petBreedAS;
    case dogBreedAS.type:
      return dogBreedAS;
    default:
      console.warn('❌ You need to add your Autosuggest variant to the autoSuggestMap'); // eslint-disable-line
      return {};
  }
};



// WEBPACK FOOTER //
// ./src/utilities/form/autoSuggest/autoSuggestMap.js